ServicesCtrl.$inject = ['Combobox', '$http', '$rootScope', '$scope', '$state', '$stateParams', 'PortalApi', 'Locations', 'configs', 'Notification', '$translate', 'Authentication', 'staticCategories', 'Localization'];

function ServicesCtrl(Combobox, $http, $rootScope, $scope, $state, $stateParams, PortalApi, Locations, configs, Notification, $translate, Authentication, staticCategories, Localization) {
    var BigNumber = require('bignumber.js');
    var categoryId = $stateParams.categoryId;
    var lastSearchQuery = '';
    var off = 12;

    $scope.configs = configs;
    $scope.getServices = search;
    $scope.searchServices = search;
    $scope.auth = Authentication;
    $scope.serviceCategoryId = categoryId;
    $scope.selectedStreetName = '';
    $scope.selectedHousholdID = '';

    $scope.hh_endpoint = '';

    $scope.state = '';
    $scope.new_address = {
        name: '',
        streetId: '',
        cityID: '',
        house: {
            number: '',
            secondNumber: '',
            letter: '',
            block: ''
        },
        apartment: ''
    };
    $scope.vocabularies = {
        cities: [],
        streets: []
    };
    $scope.selectedHoushold = {
        street: {},
        city: {}
    };
    $scope.households = [];
    $scope.householdInfo = {
        success: false,
        utilities: [],
        other: []
    };
    $scope.locationTypes = [ 'SETTLEMENTS', 'STREETS' ];
    $scope.locations = [
        {
            label: 'HOUSEHOLDS.CITY',
            type: 'SETTLEMENTS',
            value: '',
            disabled: false
        },
        {
            label: 'HOUSEHOLDS.STREET',
            type: 'STREETS',
            value: '',
            disabled: true,
        }
    ];
    $scope.autocompleteLibrary = [];

    function search(query) {
        var data = {
            query: query,
            category: !categoryId || categoryId === 'all' ? 0 : parseInt(categoryId),
            sortByPayments: categoryId !== 'favorites' ? true : false,
            onlyFavorites: categoryId === 'favorites' ? true : false,
            hiddenCategory: categoryId === 'other' ? $scope.statCategories : null
        };

        lastSearchQuery = query;
        data.location = Locations.location.id;
        off = 12;

        $scope.preLoader = true;

        if ($stateParams.subscribe) {
            data.twoStep = true;
        }


        PortalApi.getServices(data)
            .then(function(response) {
                $scope.services = [];/*to avoid dublicates after push*/

                response.map(function (result) {
                    $scope.services.push(result);
                });

                if(response.length < 12){
                    $scope.services_new = false;
                }else{
                    $scope.services_new = true;
                }

                if(!response.length && categoryId === 'favorites'){
                    $scope.noFavorites = true;
                }

                $scope.preLoader = false;
            })
    }

    $scope.getHouseholds = function () {
        $http({
            method: 'GET',
            url: $scope.hh_endpoint+'/households'
        }).then(function successCallback(response) {
            $scope.households = response.data;
        }, function errorCallback(error) {
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
        });
    };
    $scope.getHouseholdInfo = function (hhId, street) {
        $scope.preLoader = true;
        $scope.clear();
        $scope.selectedStreetName = street;
        $scope.selectedHousholdID = hhId;

        $http({
            method: 'GET',
            url: $scope.hh_endpoint+'/households/'+hhId
        }).then(function successCallback(response) {
            $scope.preLoader = false;
            $scope.householdInfo = {
                success: false,
                utilities: [],
                other: []
            };
            if (response.data.length) {
                response.data.forEach(function(item) {
                    if (item.service_id == 10317 || item.service_id == 14145) {
                        $scope.householdInfo.utilities.push(item);
                    } else {
                        $scope.householdInfo.other.push(item);
                    }
                });
            }
            $scope.householdInfo.success = true;
        }, function errorCallback(error) {
            $scope.preLoader = false;
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
        });
    };

    $scope.changeState = function (state) {
        $scope.state = state;
    };

    $scope.addAddress = function (data) {
        $scope.preLoader = true;

        var newData = {
            house: {
                block: parseInt(data.house.block) || '',
                number: '',
                letter: '',
                secondNumber: '',
                secondLetter: ''
            },
            name: data.name,
            streetId: $scope.selectedHoushold.street.id,
            apartment: parseInt(data.apartment) || ''
        };

        if(data.house.number.indexOf('/') != -1){

            var i = data.house.number.indexOf('/');

            newData.house.number = parseInt(data.house.number.slice(0, i)).toString();
            newData.house.letter = data.house.number.slice(0, i).replace(/[0-9]/g, '');

            newData.house.secondNumber = parseInt(data.house.number.slice(++i)).toString();
            newData.house.secondLetter = data.house.number.slice(++i).replace(/[0-9]/g, '');

        } else {
            newData.house.letter = data.house.number.replace(/[0-9]/g, '');
            newData.house.number = parseInt(data.house.number).toString();
        }

        $http({
            method: 'POST',
            url: $scope.hh_endpoint+'/households',
            data: newData
        }).then(function successCallback(response) {
            $scope.preLoader = false;

            $scope.clear();
            $scope.getHouseholds();
        }, function errorCallback(error) {
            $scope.preLoader = false;

            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
        });
    };

    $scope.deleteHouseholds = function(hhId) {
        if (window.confirm('Подтвердите удаление?')) {
            $scope.preLoader = true;
            $http({
                method: 'DELETE',
                url: $scope.hh_endpoint+'/households/'+hhId
            }).then(function successCallback(response) {
                $scope.clear();
                $scope.preLoader = false;
                $scope.getHouseholds();
            }, function errorCallback(error) {
                $scope.preLoader = false;
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
            });
        }
    };

    $scope.clear = function () {
        $scope.state = '';
        $scope.selectedStreetName = '';
        $scope.selectedHousholdID = '';
        $scope.householdInfo = {
            success: false,
            utilities: [],
            other: []
        };
        $scope.new_address = {
            name: '',
            streetId: '',
            house: {
                number: '',
                secondNumber: '',
                letter: '',
                block: ''
            },
            apartment: ''
        };
        $scope.selectedHoushold = {
            street: {},
            city: {}
        };
        $scope.locations = [
            {
                label: 'HOUSEHOLDS.CITY',
                type: 'SETTLEMENTS',
                value: '',
                disabled: false
            },
            {
                label: 'HOUSEHOLDS.STREET',
                type: 'STREETS',
                value: '',
                disabled: true,
            }
        ];
    };
    $scope.toService = function(template, invoice) {
        var fields = {};

        $scope.preLoader = true;

        if (Array.isArray(template.fields)) {
            template.fields.forEach(function (field) {
                fields[field.name] = {
                    value: field.value
                };
            });
        }
        else {
            fields = template.fields;
        }

        $state.go('pages.payment', {
            amount: new BigNumber(invoice.amount).dividedBy(100).toFixed(2),
            hh: {
                templateId: $scope.selectedHousholdID,
                serviceName: invoice.name,
                streetName: $scope.selectedStreetName
            },
            serviceId: template.service_id,
            url: template.service_id,
            fields: fields,
            hhTemplate: false,
            autoCheck: true
        });

        $scope.selectedStreetName = '';
    };

    function init() {
        if ($scope.auth.isLogged) {
                search($scope.query);
                $scope.getHouseholds();

                if ($stateParams.housholdID) {
                    $scope.getHouseholdInfo($stateParams.housholdID);
                }
        } else {
            $state.go('pages.main').then(function () {
                $rootScope.STATE_GOIN = false;
                window.scrollTo(0,0);
            });
        }
    }

    init();

    var listenerChangeLang = $rootScope.$on('changeLang', init);
    var listenerChangeLocation = $rootScope.$on('changeLocation', init);

    $scope.$on('$destroy', function () {
        listenerChangeLang();
        listenerChangeLocation();
    });

    $scope.searchLocation = function (data, vocabulary, type) {
        if (data) {
            $http({
                method: 'GET',
                url: $scope.hh_endpoint+'/vocabulary?q='+data+'&type='+type+'&offset=0&limit=0&lang='+Localization.active+( (type == 'STREETS') ? ('&parentId='+$scope.new_address.cityID) : '')
            }).then(function successCallback(response) {
                if(type == 'STREETS') $scope.vocabularies.streets = response.data;
                if(type == 'SETTLEMENTS') $scope.vocabularies.cities = response.data;
                $scope.autocompleteLibrary = [];
                response.data.forEach( function (item) {
                    $scope.autocompleteLibrary.push(item.type+' '+item.name+', '+item.region_name);
                })
            }, function errorCallback(error) {
                Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.OOPS_ERROR', 5, true);
            });
        } else if (!data) {
            if(type == 'SETTLEMENTS') {
                $scope.selectedHoushold.city = {};
                $scope.new_address.cityID = '';
                $scope.locations.forEach(function (location) {
                    if(location.type === 'STREETS'){
                        location.disabled = true;
                    }
                    if(location.type === 'SETTLEMENTS'){
                        location.value = '';
                    }
                });
            }

            if (type == 'STREETS') {
                $scope.selectedHoushold.street = {};
                $scope.selectedStreetName = '';
                $scope.locations.forEach(function (location) {
                    if(location.type === 'STREETS'){
                        location.value = '';
                    }
                });
                // $scope.new_address = {
                //     streetId: '',
                // };
            }
        }
    };

    $scope.selectLocation = function (data, type) {
        if(type == 'SETTLEMENTS') {
            $scope.vocabularies.cities.forEach( function (city) {
                if( (city.type+' '+city.name+', '+city.region_name ) === data){
                    $scope.selectedHoushold.city = city;
                    $scope.new_address.cityID = city.unique_id;
                    $scope.locations.forEach(function (location) {
                        if(location.type === 'STREETS'){
                            location.disabled = false;
                        }
                    })
                }
            })
        }else if(type == 'STREETS') {
            $scope.vocabularies.streets.forEach( function (street) {
                if( (street.type+' '+street.name+', '+street.region_name) === data ){
                    $scope.selectedHoushold.street = street;
                }
            })
        }
    };

    $scope.closeAll = function() {
        $scope.id = null;
        $scope.renameTmpl = false;
        $scope.changeTmpAmount = false;
        $scope.openMenu = false;
    }
    $scope.doChanges = function (obj) {
        $scope.closeAll();
        $scope.id = obj.id;
        $scope.renameTmpl = true;
    };
     $scope.sendNewName = function(obj, newName){
        var data = {
            tmplID: obj.id,
            hhID: $scope.selectedHousholdID,
            query: {
                name: newName,
                status: 'ACTIVE'
            }
        }
        $scope.oldNameTemplate = obj.name;
        obj.name = newName;
        PortalApi.renameHHTemplate(data).then(function (response) {
            Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.TEMPLATE_SAVE', 5, true);
        },function (response) {
            obj.name = $scope.oldNameTemplate;
            console.log('When err we see name : ' + obj.name );
            Localization.notifyTemplate('error', 'ERRORS.TEMPLATE_SAVE', 5, true);

        });
        $scope.renameTmpl = false;
        $scope.id = null;
    };
    $scope.deleteTemplate = function(id) {
        $scope.preLoader = true;
        var data = {
            tmplID: id,
            hhID: $scope.selectedHousholdID
        }
        PortalApi.deleteHHTemplate(data).then(function(response) {
            $scope.getHouseholdInfo($scope.selectedHousholdID, $scope.selectedStreetName);
            Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.TEMPLATE_DELETED', 5, true);
            $scope.preLoader = false;
        }, function(response) {
            Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
            $scope.preLoader = false;
        }
        );
    }

};

module.exports = ServicesCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/households/controllers/households.js
 ** module id = 262
 ** module chunks = 1
 **/